export {
  initializePlatformBrowser,
  PlatformBrowserInit,
} from "./initialize-platform-browser";

export { getSentryInitBase } from "@outschool/platform/initialize";
